import React from 'react';
import PropTypes from 'prop-types';

const Image = props => (
  <img className="image" src={props.src} alt={props.alt} />
);

Image.propTypes = {
  src: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({}),
  ]),
  alt: PropTypes.string,
};

export default Image;



// WEBPACK FOOTER //
// ./src/components/Image/Image.jsx